// extracted by mini-css-extract-plugin
export default {"detailItem":"DetailItem_detailItem__1au9+","label":"DetailItem_label__rfOaD","value":"DetailItem_value__5E3N8"};